import { AxiosError } from 'axios';

import logAxiosError from './logAxiosError';

const logError = (error: unknown): void => {
  // Currently using Axios library for all ajax fetches
  return logAxiosError(error as AxiosError);
};

export default logError;
